import type { DocumentUploadSdkConfig } from "@highnoteplatform/types";
import type { DocumentUploadLink } from "@highnoteplatform/internal-sdk/generated/graphql";

import { documentUploadClient } from "./documentUploadClient";
import { mapError } from "./errorHandler";

export const fetchUploadStatus = async (
  config: DocumentUploadSdkConfig,
  url: string
): Promise<string | undefined> => {
  const client = documentUploadClient(config);
  const { onError, documentUploadSessionId } = config;
  try {
    const { data } = await client.FindDocumentUploadSession({
      id: documentUploadSessionId,
    });

    if (
      (data.node?.__typename ===
        "USAccountHolderApplicationDocumentUploadSession" ||
        data.node?.__typename === "CheckPaymentDocumentUploadSession") &&
      data.node.status !== undefined
    ) {
      const { documents } = data.node;
      if (documents !== undefined) {
        const uploadedDocument = documents.find(
          (item) =>
            item?.__typename === "DocumentUploadLink" && item.uploadUrl === url
        ) as DocumentUploadLink;
        return uploadedDocument.status;
      }
    }
  } catch (error) {
    mapError(error, onError);
  }

  return undefined;
};
